<template>
    <tr>
        <td>
          {{item.ip}}
        </td>
        <td>
          {{item.operacao}}
        </td>
        <td>
          {{item.observacao}}
        </td>

        <td class="edit">

            <v-icon size="20"
                    slot="activator"
                    v-tooltip="$t('message.generics.message.remove')"
                    @click="remove">mdi-delete</v-icon>

        </td>
        <app-confirmation-modal :value="!!pendingRemove"
                                :confirm-label="$t('message.generics.message.confirm')"
                                @confirm="confirmRemove"
                                @cancel="cancelRemove">
          <span slot="heading">
            {{$t('message.generics.message.exclude')}}
          </span>
          <span>
            {{$t('message.generics.message.confirmExclusion')}}
          </span>
        </app-confirmation-modal>
    </tr>
</template>

<script>
    import AppConfirmationModal from '@components/ConfirmationModal'
    import EventBus from '@packages/event-bus/index'
    export default {
        components: {
            AppConfirmationModal
        },

        props: {
            dataItem: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                entity: 'ipfirewall',
                pendingRemove: null
            }
        },

        computed: {
            item() {
                return this.dataItem
            },

        },

        methods:{
            remove() {
                this.pendingRemove = this.item.id;
            },
            async confirmRemove() {
                await this.$api.ipfirewall.remove(this.item.id)
                this.pendingRemove = null
                EventBus.$emit('LOAD_IPFIREWALL')
            },

            cancelRemove(){
                this.pendingRemove = null
            },

        }
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.edit {
  .mdi {
    font-size: 18px;

    &:not(:last-child) {
      margin-right: 6px;
    }
  }
}
.icon-green {
  color: $primary;
}
</style>
